import PricingFeatures from "@/components/PricingFeatures";
import SEO from "@/components/SEO";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart3, Sparkles } from "lucide-react";

const Features = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <SEO 
        title="Premium Features - Oraculus:X Crypto Trading Signals | Live Alerts & Risk Management"
        description="Explore Oraculus:X premium features: Real-time crypto signals, multiple pro traders, instant notifications, community support, and professional risk management tools."
      />
      <div className="fixed inset-0 bg-gradient-mesh animate-mesh-move opacity-40" />
      <div className="fixed inset-0 bg-gradient-opal-radial animate-gradient-shift" style={{ backgroundSize: '200% 200%' }} />
      
      <main className="relative z-10 pt-20 md:pt-32">
        {/* Dashboard v1.0 Highlight */}
        <section className="py-12">
          <div className="container px-4">
            <Card className="p-6 md:p-8 bg-gradient-primary relative overflow-hidden border-2 border-green-500/30 max-w-4xl mx-auto">
              <div className="absolute inset-0 bg-card/90 backdrop-blur-2xl" />
              <div className="relative z-10 flex flex-col md:flex-row items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="p-4 bg-gradient-primary rounded-2xl">
                    <BarChart3 className="w-12 h-12" />
                  </div>
                </div>
                <div className="flex-1 text-center md:text-left space-y-2">
                  <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                    <Sparkles className="w-5 h-5 text-green-500 animate-pulse" />
                    <span className="text-xs font-bold text-green-500 uppercase tracking-wider">New Feature Live</span>
                  </div>
                  <h3 className="text-2xl font-bold">Dashboard v1.0 — Live Performance Analytics</h3>
                  <p className="text-muted-foreground">
                    Real-time tracking with detailed metrics, win rates, and ROI monitoring. Available now for premium members.
                  </p>
                </div>
                <Button 
                  size="lg" 
                  className="bg-gradient-primary hover:shadow-glow-primary whitespace-nowrap"
                  asChild
                >
                  <a href="https://dashboard.oraculusx.com" target="_blank" rel="noopener noreferrer">
                    View Dashboard
                  </a>
                </Button>
              </div>
            </Card>
          </div>
        </section>
        
        <PricingFeatures />
      </main>
    </div>
  );
};

export default Features;
